/**
 * GestureSettings.tsx
 * Gestureカードの設定ダイアログの中身（モーション選択）
 */
import { useReactFlow } from '@xyflow/react';
import type { NodeSettingsProps } from '../../types';
import { DEFAULT_GESTURE_MOTION_ID, GESTURE_MOTIONS } from '../../config/gestureMotions';
import { useFlowDisplayLanguage } from '../../displayLanguage';

export function GestureSettings({ node }: NodeSettingsProps<'gesture'>) {
  const { updateNodeData } = useReactFlow();
  const displayLanguage = useFlowDisplayLanguage();

  return (
    <label className="block" data-product-tour="card-input-1">
      <span className="mb-1 block text-sm font-medium text-slate-700">
        {displayLanguage === 'en' ? 'motion' : 'うごき'}
      </span>
      <select
        value={node.data.motionId ?? DEFAULT_GESTURE_MOTION_ID}
        onChange={(event) => updateNodeData(node.id, { motionId: event.target.value })}
        className="w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-base focus:outline-none focus:ring-2 focus:ring-violet-400"
      >
        {GESTURE_MOTIONS.map((option) => (
          <option key={option.id} value={String(option.id)}>{option.label}</option>
        ))}
      </select>
    </label>
  );
}
